import Layout from 'components/layout/Layout'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Blog from 'features/blog/Blog'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import type { BlogProps } from 'features/blog/types'
import type { SeoProps } from 'components/seo/types'
import { cmsLib } from 'lib'
import { mapCmsBlogArticlesToArticles, mapCmsBlogExternalArticlesToArticles, sortArticlesOnPublishedDate } from 'utils/cms'
import { useTranslation } from 'next-i18next/pages'

const BlogPage = (props: BlogProps) => {
  // i18n
  const { t } = useTranslation('blog')

  // Constants
  const SEO: SeoProps = {
    description: t('seo.description'),
    image: props?.content?.seo?.seoImage?.url,
    title: t('seo.title')
  }

  return (
    <Layout seo={SEO}>
      <Blog {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  try {
    // Fetch page content, categories & articles
    const [content, categories, blogArticles, blogExternalArticles] = await Promise.all([
      cmsLib.getBlogPage(locale),
      cmsLib.getBlogCategories(locale),
      cmsLib.getBlogArticles(locale),
      cmsLib.getBlogExternalArticles(locale)
    ])

    return {
      props: {
        articles: sortArticlesOnPublishedDate([
          ...mapCmsBlogArticlesToArticles(blogArticles),
          ...mapCmsBlogExternalArticlesToArticles(blogExternalArticles)
        ]),
        categories,
        content: content ?? null,
        ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'projects', 'blog'], i18nConfig))
      } satisfies BlogProps,
      revalidate: 10 // re-generate page when a request comes in, once every 10 seconds
    }
  } catch (_) {
    return {
      props: {
        articles: [],
        categories: [],
        content: null,
        ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'projects', 'blog'], i18nConfig))
      } satisfies BlogProps,
      revalidate: 10 // re-generate page when a request comes in, once every 10 seconds
    }
  }
}

export default BlogPage
